import React, { useState } from 'react'
import { Message, Icon, Button } from 'semantic-ui-react'
import { SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic'
import firebase from 'firebase'

import { call } from 'lib/util'

const EmailVerification = ({ user }: { user: firebase.User }) => {
  if (user.emailVerified) {
    return null
  }

  const [icon, setIcon] = useState<SemanticICONS>('mail outline')

  const onClick = async () => {
    setIcon('circle notched')
    try {
      const authToken = await user.getIdToken()
      await call('/api/user/sendEmailVerification', null, authToken)
      setIcon('checkmark')
    } catch (err) {
      setIcon('x')
    }
  }

  return (
    <Message icon warning>
      <Icon name={icon} loading={icon === 'circle notched'} />
      <Message.Content>
        <Message.Header>Email Verification</Message.Header>
        <p>
          To avoid spam, we ask that you please verify your email to be able to
          receive email alerts.
        </p>
        <Button
          onClick={onClick}
          disabled={icon === 'circle notched' || icon === 'x'}
        >
          {icon !== 'x' ? 'Resend Verification Email' : 'Please try later.'}
        </Button>
        <Button
          onClick={() => {
            window.location.reload()
          }}
          basic
        >
          I clicked the verification link
        </Button>
      </Message.Content>
    </Message>
  )
}

export default EmailVerification
